import React from 'react'

import Tridi from 'react-tridi-wrapper';

import icon from './../../../UI/general/BikeMenu/personaliza.svg'
import back from './../../../UI/general/back.svg'
import { routesData } from '../../../data/routes.data';


class BikeView extends React.Component{
    constructor(props){
        super(props);
        this.state = {updatedSet: [], zoom: 120}
    }

    componentDidUpdate(prevProps){
        if(prevProps.currentColor !== this.props.currentColor){
            this.setState({
                updatedSet: routesData()[0][this.props.selectedBike.Nombre + " " + this.props.currentColor]
            }, () => {
                var container = document.getElementsByClassName('tridi-viewer-image')[0]
                container.style.minWidth = String(this.state.zoom) + "%"
                container.style.maxWidth = String(this.state.zoom) + "%"
            })
        }
    }

    createColorStructure = () => {
        return(
            <div className='color-container-mobile'>
                {
                    this.props.currentColorsArray.map((color, index) => 
                        <div className='color-individual-container-mobile' key={index}>
                            <div 
                                className={this.props.currentColorIndex === index ? 'color-ball selected-color':'color-ball'} 
                                style={{background:"linear-gradient(125deg,"+ color.hexa +" 40%,"+ color.hexaAlt+")"}} 
                                onClick= {() => {this.props.handleChangeColors(index)}}
                                />
                        </div>
                    )
                }
            </div>
        )
    }

    handleZoom = (payload) => {
        this.setState({
            zoom: this.state.zoom + payload > 150 ? 150: this.state.zoom + payload < 90 ? 90: this.state.zoom + payload 
        }, () => {
            var container = document.getElementsByClassName('tridi-viewer-image')[0]
            container.style.minWidth = String(this.state.zoom) + "%"
            container.style.maxWidth = String(this.state.zoom) + "%"
        })
    }
    
    render(){
        return(
            <div className={this.props.isSpinOpened ? 'bike-view-main-mobile fade-in':'bike-view-main-mobile fade-out'}>
                <div className='bike-view-back-mobile' onClick={() => {this.props.handleCloseSpin()}}>
                    <img src={back}/>
                </div>
                {
                    /*this.state.updatedSet.length > 0 ?
                    <Viewer images={this.state.updatedSet} zoom={this.state.zoom}/> : null*/
                }
                {
                    <Tridi element={'.tridi-basic'} location={this.state.updatedSet} format="webp" count="59" />
                }
                <div className='bike-view-options-mobile'>
                    <div className='bike-view-icon-container-mobile'>
                        <img src={icon}/>
                        <div>Color</div>
                    </div>
                    {
                        this.props.currentColorsArray.length > 0 ?
                        this.createColorStructure():null
                    }
                    <div className='bike-view-zoom-mobile'>
                        <div className='plus' onClick={() => {this.handleZoom(+5)}}>
                            +
                        </div>
                        <div className='minus' onClick={() => {this.handleZoom(-5)}}>
                            -
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default BikeView
